import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';

const ProtectedRoute = ({ children }) => {

    const location = useLocation();
    const { isLoading, isLoggedIn } = useAuth();

    // 로딩 중인 경우 아무것도 렌더링하지 않고 기다림
    if (isLoading) {
        return null;
    }
    
    // 로딩이 끝났고, 로그인되지 않은 경우
    if (!isLoggedIn) {
        return <Navigate to="/user/login" replace state={{ from: location.pathname }} />;
    }

    // 로딩이 끝났고, 로그인된 경우 자식 컴포넌트 렌더링
    return children;
};

export default ProtectedRoute;
